export default __webpack_public_path__ + "static/media/user.15cd3309.png";